<style src="./stye.scss">
</style>

<script lang="ts">
  import Modal from "@components/modal";
  import Button from "@components/button";
  import TextInput from "@components/textInput";

  export let isOpen = false;
  export let onClose = () => null;
  export let onSubmit = () => null;
  export let title;
</script>

<Modal isOpen="{isOpen}" title="Como podemos te chamar?" onClose="{onClose}">
  <form on:submit|preventDefault="{() => onSubmit(title)}">
    <select bind:value="{title}">
      <option value="{null}">Selecione</option>
      <option value="{'Aluno'}">Aluno</option>
      <option value="{'Aluna'}">Aluna</option>
      <option value="{'Alune'}">Alune</option>
    </select>

    <Button
      title="Salvar"
      onClick="{() => onSubmit(title)}"
      disabled="{!title}" />
  </form>
</Modal>
